module.exports = __webpack_public_path__ + "static/media/trashIcon.d0ebbc12.svg";